import i18n from 'i18n';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { TargetDomain } from 'data/targetDomain/targetDomain.types';

export enum TargetDomainMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newTargetDomain: TargetDomain = {
  id: '',
  domain: '',
  description: '',
};

export const targetDomainColumnDefs: ColDef[] = [

  {
    headerName: i18n.t('targetDomain.grid.domain'),
    field: 'domain',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'name',
    flex: 1,
    maxWidth: 200,
  },
  {
    headerName: i18n.t('targetDomain.grid.description'),
    field: 'description',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'name',
    flex: 1,
    maxWidth: 200,
  },
];
